import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../utils/api';

export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get('/users/');
      
      if (!Array.isArray(response.data)) {
        console.error('Invalid response format:', response.data);
        return rejectWithValue('Invalid response format from server');
      }

      return response.data;
    } catch (error) {
      console.error('Error fetching users:', error.response || error);
      return rejectWithValue(
        error.response?.data?.detail || 
        error.message || 
        'Failed to fetch users'
      );
    }
  }
);

export const fetchUserProgress = createAsyncThunk(
  'users/fetchUserProgress',
  async (userId, { rejectWithValue }) => {
    try {
      const response = await api.get(`/users/${userId}/progress/`);
      console.log('Response:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error details:', {
        response: error.response,
        status: error.response?.status,
        data: error.response?.data,
        headers: error.response?.headers
      });
      return rejectWithValue(
        error.response?.data?.detail || 
        error.message || 
        'Failed to fetch progress'
      );
    }
  }
);

const initialState = {
  users: [],
  selectedUserProgress: [],
  currentUserProgress: [],
  userStats: {},  // Store stats for all users
  loading: false,
  error: null,
};

const usersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.users = action.payload;
        state.error = null;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch users';
        console.error('Failed to fetch users:', action.payload);
      })
      .addCase(fetchUserProgress.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserProgress.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedUserProgress = action.payload.selectedUserProgress;
        state.currentUserProgress = action.payload.currentUserProgress;
        // Store stats by user ID
        state.userStats = {
          ...state.userStats,
          [action.meta.arg]: action.payload.selectedUserStats
        };
        state.error = null;
      })
      .addCase(fetchUserProgress.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // Clear progress data on error
        state.selectedUserProgress = [];
        state.currentUserProgress = [];
      });
  },
});

export default usersSlice.reducer; 